import Vue from "vue";
import ZrBaseLayout from "zr-base-layout";
import { title } from "../config/settings";
Vue.use(ZrBaseLayout);
ZrBaseLayout.commUtilsInstall(Vue, { title });
